<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>外部机构设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="between">
      <div class="left_con">
        <el-input size="mini"
                  style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                  placeholder="输入关键字进行过滤"
                  v-model="filterText">
        </el-input>
        <el-tree
          :data="orgList"
          :props="treeProps"
          @node-click="handleNodeClick"
          :highlight-current="true"
          node-key="id"
          :filter-node-method="filterNode"
          ref="tree"
        >
        </el-tree>
      </div>
      <div class="table_container" style="border: 0 solid rgb(222,222,222);margin: 10px 0">
        <el-button size="mini" plain @click="showOutOrgDialog(null,1)"
                   v-if="authorities.includes('system.out.org.new')">添加外部机构</el-button>
        <el-table height="520px" :data="outOrgList" fit border stripe="stripe"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}" >
          <el-table-column
            align="center"
            label="操作" width="100" >
            <template slot-scope="scope" >
              <div style="display: flex;justify-content: space-around">
                <el-link type="primary" v-if="authorities.includes('system.out.org.update')" icon="el-icon-edit"
                         @click="showOutOrgDialog(scope.row,2)"></el-link>
                <el-link type="danger" v-if="authorities.includes('system.out.org.delete')" icon="el-icon-delete"
                         @click="deleteOutOrg(scope.row)"></el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="outOrgName"
            label="外部机构名称" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="purchaseLevel"
            label="出库价格等级"
            :formatter="purchaseLevelFormatter">
          </el-table-column>
          <el-table-column
            align="center"
            prop="address"
            label="地址"
            >
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="联系电话"
            >
          </el-table-column>
        </el-table>

        <div style="margin-top: 3px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加外部机构 -->
    <el-dialog
      :title="outOrgTitle"
      :visible.sync="outOrgDialogVisible"
      width="55%"
      style="position: absolute"
      custom-class="dialog-height"
      :close-on-click-modal="false"
    >
      <div class="outside_con">
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <div style="display: flex;justify-content: space-between;margin-top: 30px;">
          <div style="margin-bottom: 10px;text-align: center">
            机构名称：
            <el-input v-model="outOrg.outOrgName" placeholder="请输入内容" size="mini" style="width: 250px"></el-input>
          </div>
          <div style="margin-bottom: 10px;text-align: center">
            机构地址：
            <el-input v-model="outOrg.address" placeholder="请输入内容" size="mini" style="width: 250px"></el-input>
          </div>
        </div>

        <div style="display: flex;justify-content: space-between;margin-top: 50px;">
          <div style="margin-bottom: 10px;text-align: center">
            联系电话：
            <el-input v-model="outOrg.phone" placeholder="请输入内容" size="mini" style="width: 250px"
                      onkeyup="value=value.replace(/[^\d-]/g,'')"></el-input>
          </div>
          <div style="margin-bottom: 10px;text-align: center">
            出库价格等级：
            <el-radio-group v-model="outOrg.purchaseLevel" @change="purchaseLevelHandle">
              <el-radio  :label="1">1级价</el-radio>
              <el-radio  :label="2">1.5级价</el-radio>
              <el-radio  :label="3">2级价</el-radio>
            </el-radio-group>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeOutOrgDialog">取 消</el-button>
            <el-button size="mini" @click="createOutOrg">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      authorities:'',
      currentOrgId:'',
      userId:'',
      outOrgTitle:'',
      orgList: [],
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      filterText: '',
      outOrgList:[],

      outOrg:{
        outOrgName:'',
        address:'',
        phone:'',
        purchaseLevel:'',
        creator:'',
        parentId:'',
        modifier:''
      },

      outOrgPurchaseLevelText:[
        {purchaseLevel:1,name:'1级价'},
        {purchaseLevel:2,name:'1.5级价'},
        {purchaseLevel:3,name:'2级价'}
      ],

      outOrgDialogVisible:false,
      outOrgOperatorType:'',

      selectOrgId:'',

      currentPage: 1,
      pageSize:20,
      pageTotal:0
    }
  },
  methods:{
    async handleNodeClick(data) {
      this.outOrg.parentId = data.id;
      this.selectOrgId = data.id;
      await this.loadOutOrg(data);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    showOutOrgDialog(data, type){
      this.outOrgOperatorType = type;
      if (type === 1){
        this.outOrgTitle = "新建外部机构";
        this.outOrg.outOrgName = '';
        this.outOrg.address = '';
        this.outOrg.phone = '';
        this.outOrg.purchaseLevel = '';
      }
      if (type === 2){
        this.outOrgTitle = "编辑外部机构"
        this.outOrg = data;
      }
      this.outOrgDialogVisible = true;
    },
    closeOutOrgDialog(){
      this.outOrgDialogVisible = false;
    },
    async deleteOutOrg(row){
      const {data:res} = await this.$http.delete(`outOrg/delete/id/${row.id}`);
      if (res.code !== 200){
        return this.$message.error(res.msg);
      }
      if (res.code === 200){
        this.$message.success("删除成功！");
      }
      await this.loadOutOrg();
      this.closeOutOrgDialog();
    },
    async loadOrg(){
      const {data:res} = await this.$http.get(`/orgs/areaList/orgId/${this.currentOrgId}`);
      this.orgList = [res.data];
    },
    async loadOutOrg(){
      //根据机构id查询外部机构
      const {data:res} = await this.$http.get(`outOrg/orgId/${this.selectOrgId}/pageNum/${this.currentPage}/pageSize/${this.pageSize}`);
      if (res.code === 200){
        this.outOrgList = res.data.list;
        this.pageTotal = res.data.total;
      }
    },
    purchaseLevelHandle(val){
      this.outOrg.purchaseLevel = val;
    },
    async createOutOrg(){
      if (this.outOrgOperatorType === 1){
        this.outOrg.creator = this.userId;
        const {data:res} = await this.$http.post(`outOrg/add`,this.outOrg);
        if (res.code !== 200){
          return this.$message.error(res.msg);
        }
      }
      if (this.outOrgOperatorType === 2){
        this.outOrg.modifier = this.userId;
        const {data:res} = await this.$http.put(`outOrg/update`,this.outOrg);
        if (res.code !== 200){
          return this.$message.error(res.msg);
        }
        if (res.code === 200){
          this.$message.success("修改成功！");
        }
      }
      await this.loadOutOrg();
      this.closeOutOrgDialog();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      console.log(`每页 ${val} 条`);
      this.loadOrders();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.loadOrders();
    },
    purchaseLevelFormatter(row){
      let value = "";
      for (let i = 0; i < this.outOrgPurchaseLevelText.length; i++){
        let item = this.outOrgPurchaseLevelText[i];
        if (row.purchaseLevel === item.purchaseLevel) {
          value = item.name;
          break;
        }
      }
      return value;
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
.el-dialog__title{
  color: #333;
}
.el-dialog__close{
  color: #333 !important;
}
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_con{
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  /*border: 1px solid;*/
}
.table_container{
  flex: 4;
}
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
}
/deep/ td {
  padding: 2px ;
}
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.outside_con{
  height: 250px;
}
.dialog-footer{
  display: flex;
  margin-top: 50px;
  //margin: 10px 10px;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/OutOrg.vue